import { Component, OnInit, Input, OnChanges, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { NgForm } from '@angular/forms';

import { EmailAddress } from '../../../models/email-address';

import { EmailAddressService } from '../../../services/contacts/email-address.service';
import { NotyService } from '../../../services/common/noty.service';

@Component({
  selector: 'app-email-address-form',
  templateUrl: './email-address-form.component.html',
  styleUrls: ['./email-address-form.component.scss'],
})
export class EmailAddressFormComponent implements OnInit, OnChanges {
  /**
   * Contact id for email address
   */
  @Input() contactId: number;

  /**
   * Email address being created/edited
   */
  @Input() emailAddress: EmailAddress = new EmailAddress();

  /**
   * Emit saved event to parent component
   * @param {EventEmitter<boolean> = new EventEmitter(} ) saved Event emitter to emit saved event to parent component
   */
  @Output() saved: EventEmitter<boolean> = new EventEmitter();

  /**
   * Indicates if form has been submitted atleast once
   * @type {boolean}
   */
  formSubmitted: boolean = false;

  /**
   * Indicates if form is processing
   * @type {boolean}
   */
  formSubmitting: boolean = false;

  /**
   * Inject dependencies
   * @param {EmailAddressService} private emailAddressService Service for email address resource
   * @param {NotyService}         private notyService         Service for UI notification
   */
  constructor(private emailAddressService: EmailAddressService, private notyService: NotyService) {}

  // Component lifecycle methods
  ngOnInit() {}

  /**
   * Called when component variable changes
   * @param {SimpleChanges} changes Object with variables changed in component
   */
  ngOnChanges(changes: SimpleChanges) {
    if (changes.contactId && changes.contactId.currentValue) this.emailAddress.contact_id = this.contactId;
  }

  /**
   * Save Email Address
   * @param {NgForm} currentForm Angular form
   */
  save(currentForm: NgForm) {
    this.formSubmitted = true;
    if (!currentForm.form.valid) {
      this.notyService.notify('Please check the form again', 'error', 5000, 'topRight');
      return;
    }
    this.formSubmitting = true;
    this.emailAddressService
      .save(this.emailAddress)
      .then((response_json) => {
        console.log("email address save for contact", response_json);
        this.formSubmitting = false;
        if (response_json.success) {
          this.notyService.notify(response_json.text || 'Email address saved', 'success', 5000, 'topRight');
          this.saved.emit(true);
          if (!this.emailAddress.id) {
            this.emailAddress = new EmailAddress();
            this.emailAddress.contact_id = this.contactId;
          }
        } else this.notyService.notify(response_json.text || 'Error saving email address', 'error', 5000, 'topRight');
      })
      .catch(() => {
        this.formSubmitting = false;
        this.notyService.notify('Error saving email address', 'error', 5000, 'topRight');
      });
  }
}
